/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface ChapterCompletion
 */
export interface ChapterCompletion {
    /**
     * 
     * @type {number}
     * @memberof ChapterCompletion
     */
    userId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ChapterCompletion
     */
    dateCompleted?: Date;
}

/**
 * Check if a given object implements the ChapterCompletion interface.
 */
export function instanceOfChapterCompletion(value: object): boolean {
    return true;
}

export function ChapterCompletionFromJSON(json: any): ChapterCompletion {
    return ChapterCompletionFromJSONTyped(json, false);
}

export function ChapterCompletionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChapterCompletion {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'dateCompleted': json['dateCompleted'] == null ? undefined : (new Date(json['dateCompleted'])),
    };
}

export function ChapterCompletionToJSON(value?: ChapterCompletion | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'dateCompleted': value['dateCompleted'] == null ? undefined : ((value['dateCompleted']).toISOString()),
    };
}

